export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
  // Call the event callback immediately if gtm isn't initialized
  if (typeof data.eventCallback == 'function' && !isGtmInitialized()) {
    data.eventCallback();
  }
};

export const isGtmInitialized = () => {
  return (
    typeof dataLayer !== 'undefined' &&
    dataLayer.length > 0 &&
    dataLayer.find((d) => d.event == 'gtm.load')
  );
};

export const dataLayerCheckoutOption = (step, checkoutOption) => {
  pushEcommerce({
    'event': 'checkoutOption',
    'ecommerce': {
      'checkout_option': {
        'actionField': {'step': step, 'option': checkoutOption}
      }
    }
  });
}

export const dataLayerAddToCart = (gtmEcommerceItems) => {
  pushEcommerce({
      event: "gtm_add_to_cart",
      ecommerce: {
          items: gtmEcommerceItems
      }
  });
}

export const dataLayerGtmViewCart = (cart) => {
  pushEcommerce({
    'event': 'gtm_view_cart',
    'ecommerce': {
      'currency': cart.currency,
      'value': cart.gtmGrandTotal,
      'items': cart.orderRows.map(r => r.gtmEcommerceItem),
    },
  });
}

// Maps the legacy GtmProduct shape (attached to product listing items) to a GA4
// ecommerce item. Product cards don't carry a gtmEcommerceItem, but they do carry
// gtmProduct, so we reshape it here to keep select_item consistent with the other
// GA4 events (view_item / view_item_list).
const mapGtmProductToGaItem = (p) => {
  if (!p) return null;
  const price = parseFloat(p.price);
  return {
    item_id: p.baseProductId,
    item_name: p.name,
    item_brand: p.brand,
    item_category: p.category,
    item_variant: p.variant,
    item_list_name: p.list,
    index: p.position,
    price: isNaN(price) ? undefined : price,
    quantity: p.quantity,
  };
};

// GA4 select_item — fired when a user clicks through to a product from a listing.
export const dataLayerSelectItem = (gtmProduct) => {
  const item = mapGtmProductToGaItem(gtmProduct);
  if (!item) return;
  pushEcommerce({
    event: 'select_item',
    ecommerce: {
      item_list_name: gtmProduct.list,
      items: [item],
    },
  });
};

// GA4 remove_from_cart — items are already in GA4 shape (gtmEcommerceItem).
export const dataLayerRemoveFromCart = (gtmEcommerceItems, currency, value) => {
  const items = (gtmEcommerceItems || []).filter(Boolean);
  if (items.length === 0) return;
  pushEcommerce({
    event: 'remove_from_cart',
    ecommerce: {
      currency: currency ?? items[0]?.currency,
      value,
      items,
    },
  });
};

// GA4 search — search_term is top-level, not under ecommerce.
export const dataLayerSearch = (searchTerm) => {
  const term = (searchTerm || '').trim();
  if (!term) return;
  pushEcommerce({
    event: 'search',
    search_term: term,
  });
};

// GA4 form_submit — lead tracking. Mirrors the Splendor payload shape
// (form_id + lead_type + form_data).
export const dataLayerFormSubmit = (formId, formData = {}) => {
  pushEcommerce({
    event: 'form_submit',
    form_id: formId,
    lead_type: formId,
    form_data: { ...formData },
  });
};

// Custom event — fired when a user creates a new offer/quote from the offer modal.
export const dataLayerCreateOffer = () => {
  pushEcommerce({
    event: 'create_offer',
  });
};
